import Vue from 'vue'
import axios from 'axios'
import router from './../router'

const href = window.location.href
let subdomain = '';

let baseURL = 'https://api.andromeda.staging.nscreen.com.br/';

if ( baseURL.length < 10 ) {
    baseURL = 'http://test-server-1.emotiondigital.com.br:8010/';
}

try {
  if ( href.indexOf( "analytics" ) > -1 ){
    const findDomain = href.match(/https?:\/\/([^.]+)+\.analytics(\.[^.]+)?.rightr.co/);
    subdomain = findDomain[1]
  } else {
    subdomain = '1bmg'    
  }
} catch (e){
  subdomain = '1bmg'
}

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': "Basic Og==",
      subdomain: subdomain
    },
    timeout: 30000
});

apiClient.interceptors.request.use(function(config) {
  const type = localStorage.type;
  const token = localStorage.session;
  if( token && type) {
    config.headers.Authorization = type +' '+ token;
  }
  return config
});

apiClient.interceptors.response.use(res => {
    const status = res ? res.status : undefined;
    const type = res ? res.type || res.message : '';
    const message = Vue.prototype.$respMsg.getMessage(status, type);
    res.message = message;

    if ( status >= 200 && status < 300 ){
        return Promise.resolve(res);
    } else {
        return Promise.reject(res)
    }
}, err => {
    let status = null;
    let type = null;
    if ( err && err.response ) {
        status = err.response.status;
        type = err.response.statusText;
    }
    const message = Vue.prototype.$respMsg.getMessage(status, type);
    const currentPath = router.history.current.path;

    if ( status == 401 && (
       currentPath.indexOf( "/login" ) === -1 &&
       currentPath.indexOf( "/redefinir-senha" ) === -1 &&
       currentPath.indexOf( "/esqueci-minha-senha" ) === -1 &&
       currentPath.indexOf( "/erro/" ) === -1
    )) {
      localStorage.removeItem('session');
      router.push('login');
    } else if ( status == 500 ) {
      router.push('500');
    } else if ( status == 502 ) {
      router.push('502');
    }

    if (err){
      err = {
        message: message,
        status: status
      }
    } else {
      err = {
        message: message,
        status: 500
      }
    }

    return Promise.reject(err);
});

Vue.use({
    install(Vue) {
        Vue.prototype.$http = apiClient
    }
})